import React from 'react';
import { getRandkey } from '../../../utils/helpers';

interface ImageData {
  src: string;
  lowResSrc?: string;
}

interface ImagesRotatorProps extends React.HTMLAttributes<HTMLDivElement> {
  images: ImageData[];
  className?: string;
}

export const ImagesRotator: React.FC<ImagesRotatorProps> = ({
  images = [],
  className = '',
  ...otherProps
}) => {
  return (
    <div className={`mz-images-rotator ${className}`} {...otherProps}>
        <div className="mz-images-rotator-inner">
          <div className="mz-images-rotator-content">
            {
              images.map(image => {
                return (
                  <img
                    src={image.src}
                    data-src={image.lowResSrc ? image.lowResSrc : undefined}
                    className={image.lowResSrc ? 'lazy' : ''}
                    key={getRandkey()}
                  />
                );
              })
            }
          </div>
        </div>
    </div>
  );
};

export default ImagesRotator;
